import { WebsitePage } from './website-page';
import {
    IWebsiteBuilderItem,
    WebsiteBuilderItemAbout,
    WebsiteBuilderItemAmenities,
    WebsiteBuilderItemBase,
    WebsiteBuilderItemContact,
    WebsiteBuilderItemDocuments,
    WebsiteBuilderItemFeatures,
    WebsiteBuilderItemGallery,
    WebsiteBuilderItemNeighbourhood,
    WebsiteBuilderItemWelcome
} from './items';
import { IWebsiteBuilder } from '../api-response/auth/website-builder';
import { WebsiteBuilder } from './website-builder';
import { WebsiteBuilderItemWelcomeMessage } from './items/website-builder-item-welcome-message';

export type AnyWbPageItem =
    WebsiteBuilderItemBase |
    WebsiteBuilderItemWelcome |
    WebsiteBuilderItemFeatures |
    WebsiteBuilderItemAmenities |
    WebsiteBuilderItemAbout |
    WebsiteBuilderItemWelcomeMessage |
    WebsiteBuilderItemGallery |
    WebsiteBuilderItemNeighbourhood |
    WebsiteBuilderItemContact |
    WebsiteBuilderItemDocuments;

export class WebsiteBuilderFactory {

    static setPages(wb: WebsiteBuilder, showAnnouncements = true): void {
        wb.websitePages[WebsitePage.welcome] = new WebsiteBuilderItemWelcome();
        wb.websitePages[WebsitePage.amenities] = new WebsiteBuilderItemAmenities();
        wb.websitePages[WebsitePage.about] = new WebsiteBuilderItemAbout();
        wb.websitePages[WebsitePage.welcomeMessage] = new WebsiteBuilderItemWelcomeMessage();
        wb.websitePages[WebsitePage.gallery] = new WebsiteBuilderItemGallery();
        wb.websitePages[WebsitePage.buildingFeatures] = new WebsiteBuilderItemFeatures();
        wb.websitePages[WebsitePage.neighbourhood] = new WebsiteBuilderItemNeighbourhood();
        wb.websitePages[WebsitePage.contact] = new WebsiteBuilderItemContact();
        wb.websitePages[WebsitePage.document] = new WebsiteBuilderItemDocuments(wb);

        if(showAnnouncements) {
            wb.websitePages[WebsitePage.announcements] = new WebsiteBuilderItemBase('Announcements', 'Announcements', 'announcements');
        }

        wb.pageKeys = Object.keys(wb.websitePages);
    }

    /**
     * Patches website builder
     * with passed data
     *
     * @param wb
     * @param website
     */
    static patch(wb: WebsiteBuilder, website: Partial<IWebsiteBuilder>) {
        const siteUrlParts = website.websiteUrl ? website.websiteUrl.split('.') : [];

        wb.id = website.id;
        wb.websiteName = siteUrlParts ? siteUrlParts[0] : '';
        wb.websiteTitle = website.websiteTitle;
        wb.websiteLogo = website.uploadLogo || '';
        wb.published = website.status;
        wb.themeColors = website.themeColors || wb.themeColors;

        WebsiteBuilderFactory.patchPages(wb, website);
    }

    /**
     * Patches website builder page items
     * with passed data
     *
     * @param wb
     * @param website
     */
    static patchPages(wb: WebsiteBuilder, website: Partial<IWebsiteBuilder>) {

        for(const pageKey of wb.pageKeys) {
            const pageData = website[pageKey];

            if(!pageData) {
                continue;
            }

            if (wb.websitePages.hasOwnProperty(pageKey)) {
                const page: IWebsiteBuilderItem = wb.websitePages[pageKey];
                page.value = pageData;
            }
        }

        // updates page keys ordering depends on each priority
        wb.pageKeys.sort((pageKeyA, pageKeyB) => wb.websitePages[pageKeyA].priority - wb.websitePages[pageKeyB].priority);
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/website-builder-factory.ts